<div mat-dialog-title>{{ data.title }}</div>
<div mat-dialog-content>
  <div class="search">
    <mat-form-field
      (keyup)="monitorSearch(search.value)"
      [subscriptSizing]="'dynamic'"
     appearance="outline"  floatLabel="always" >
      <mat-label>{{ 'USERS_SEARCH.search' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
        #search
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div *amIfTablet>
    <table mat-table [dataSource]="dataSource" *amIfTablet matSort>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="selected-label">
          <mat-checkbox
                color="primary" 
                #ref (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="isPartiallySelected()"
              >
              </mat-checkbox>
        </th>
        <td mat-header-cell class="border" *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)" 
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-label">{{
          'COMPANY_USERS.name' | translate
        }}</th>
        <td mat-cell *matCellDef="let user" class="name-column">
          @if (user.authID) {
          <div>
            {{ user.firstName }} {{ user.lastName }}
          </div>
          }
          @if (user.id) {
          <div>{{ user.name }}</div>
          }
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell
          *matHeaderCellDef
          class="email-label"
          >{{ 'COMPANY_USERS.email' | translate }}</th
        >
        <td mat-cell *matCellDef="let user" class="email-column">{{
          user.email
        }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
        class="branch-user-row"
        *matRowDef="let row; columns: displayedColumns" class="table-row"
      ></tr>
    </table>

    @if (usersCount > 5) {
    <mat-paginator
      #paginator
      [length]="usersCount"
      [pageSize]="5"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>
    }
  </div>

  <div *amIfMobile>
    <mat-selection-list>
      @for (user of data && dataSource.filteredData; track user) {
      <mat-list-option
        color="primary"
        (click)="
          user.branchAssignments &&
          user.branchAssignments.includes(branch.accountId)
            ? removeUser(user)
            : addUser(user)
        "
        [selected]="
          user.branchAssignments &&
          user.branchAssignments.includes(branch.accountId)
        "
        >
        @if (user.id) {
        <h5 matLine>{{ user.name }}</h5>
        }
        @if (user.authID) {
        <h5 matLine>
          {{ user.firstName }} {{ user.lastName }}
        </h5>
        }
        <p matLine>{{ user.email }}</p>
      </mat-list-option>
      }
    </mat-selection-list>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>
    {{ 'COMPANY_ADD_USERS.cancel' | translate }}
  </button>
  <button *amIfMobile mat-flat-button color="primary" [mat-dialog-close]="true">
    {{ 'COMPANY_ADD_USERS.okay' | translate }}
  </button>
  <button *amIfTablet mat-flat-button color="primary" (click)="selectedUsers()" [mat-dialog-close]="true">
    {{ 'COMPANY_ADD_USERS.okay' | translate }}
  </button>
</div>
